<div class="parcel-container">
  <div class="parcel-title">
    <span class="title-primary">Parcel Info <fa-icon
      (click)="centerOnParcel()"
      matTooltip="Click to zoom to parcel"
      matTooltipClass="fc-tooltip-map"
      [icon]="['far', 'crosshairs']"
      class="zoom-parcel"></fa-icon></span>
    @if (!readOnly) {
      <fa-icon
        (click)="removeParcel()"
        [icon]="['far', 'trash']"
        class="red remove-parcel"></fa-icon>
    }
  </div>
  <div
    class="parcel-details">
    <div class="parcel-info-table">
      <div class="parcel-row">
        <div class="row-header">Address</div>
        <div class="row-value">
          @if (parcel.id === null) {
            <span class="address-line-1">{{ buildAddressLine1(parcel) }}</span>
            @if (parcel.feature.properties.address2) {
              <span class="address-line-1">{{ parcel.feature.properties.address2 }}</span>
            }
            <span class="city-state">{{ buildAddressCityState(parcel) }}</span>
          } @else {
            <span class="address-line-1">{{ parcel.address }}</span>
          }
        </div>
      </div>
      <div class="parcel-row">
        <div class="row-header">Owner</div>
        <div class="row-value">{{ parcel.id === null ? parcel.feature.properties.owner : parcel.owner }}</div>
      </div>
      <div class="parcel-row">
        <div class="row-header">Approx. Size</div>
        <div class="row-value">{{ approxSize }} Total Acres</div>
      </div>
      <div class="parcel-row">
        <div class="row-header">Parcel Number</div>
        <div class="row-value">{{ parcel.parcelNumber }}</div>
      </div>
      @if (isAdmin && parcel.llUpdatedAt) {
        <div class="parcel-row">
          <div class="row-header">Last Refreshed</div>
          <div class="row-value">{{ parcel.llUpdatedAt | date: 'longDate' }}</div>
        </div>
        <div class="parcel-row">
          <div class="row-header">ll_uuid</div>
          <div class="row-value"><a href="https://app.regrid.com/search?query={{parcel.llUuid}}"
                                    rel="noopener noreferrer" target="_blank">{{ parcel.llUuid }}</a></div>
        </div>
      }
      @if (!parcel.inRegion) {
        <div class="parcel-not-available">
          This parcel is not available. Please remove.
        </div>
      }
    </div>
  </div>
</div>
